import { render } from "./MagicKitchenPresskit.vue?vue&type=template&id=dd6c5ffe&scoped=true"
import script from "./MagicKitchenPresskit.vue?vue&type=script&lang=js"
export * from "./MagicKitchenPresskit.vue?vue&type=script&lang=js"

import "./MagicKitchenPresskit.vue?vue&type=style&index=0&id=dd6c5ffe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6c5ffe"]])

export default __exports__